import { createSlice } from "@reduxjs/toolkit";
import moment from "moment";
export const godownStockSlice = createSlice({
  name: "godownstock",
  initialState: {
    loginError: "aaa",
    message: null,
    loading: false,
    model: false,
    drawer: false,
    hotStockloading: false,
    apiError: {},
    godownStockData: {},
    listCount: 0,
    saleListCount: 0,

    activeTab: "1",
    screen: { Type: "none", id: 0 },
    godownStockList: [],
    stockImages: [],
    qs_images : [],
    godownStockParams: {
      no_of_pages: 0,
      page_size: 10,
      page: 1,
      search: "",
      currentSort: "code",
      sortOrder: "-",
    },
    vehicleAttendanceslistCount: 0,
    vehicleAttendancesList: [],
    vehicleAttendanceParams: {
      no_of_pages: 0,
      page_size: 10,
      page: 1,
      search: "",
      currentSort: "code",
      sortOrder: "-",
    },
    qrCodeactivitylistCount: 0,
    qrCodeactivityList: [],
    qrCodeactivityParams: {
      no_of_pages: 0,
      page_size: 10,
      page: 1,
      search: "",
      currentSort: "code",
      sortOrder: "-",
    },
    QRCodeData: {},
    QRCodeModel: false,
    QRCodeStatus: true,
    commentsData: {},
    ratingModel: false,
    ratingData: {},
    imageModel: false,
    locationModel: false,
    stockImgData: {},
    stockLocationData:{},
    imageLooading: false,
    incentiveLoading: false,
  },

  reducers: {
    clearData: (state) => {
      return {
        ...state,
        loading: false,
      };
    },
    getMyStockList: (state, action) => {
      return {
        ...state,
        loading: true,
        godownStockList: [],
      };
    },
    myStockListSuccessful: (state, action) => {
      var noofpages = Math.ceil(
        action.payload.response.count / state.godownStockParams.page_size
      );
      return {
        ...state,
        listCount: action.payload.response.count,
        // godownStockList: [...state.godownStockList, ...action.payload.response.results],
        godownStockList: action.payload.response.results,
        loading: false,
        godownStockParams: {
          ...state.godownStockParams,
          no_of_pages: noofpages,
        },
      };
    },
    clearStockList: (state, action) => {
      return {
        ...state,
        loading: true,
        stockList: [],
      };
    },
    setMyStockParams: (state, action) => {
      return {
        ...state,
        godownStockParams: action.payload,
      };
    },

    getMyStockById: (state, action) => {
      return {
        ...state,
        loading: true,
      };
    },
    getQuickShellImagesById: (state, action) => {
      return {
        ...state,
        loading: true,
      };
    },
    myStockByIDSuccessful: (state, action) => {
      console.log("myStockByIDSuccessful", action.payload);
      var oldImgs = [
        {
          ...action.payload.vehicleback_image,
          imageType: "Vehicle Back Image",
        },
        {
          ...action.payload.vehiclefront_image,
          imageType: "Vehicle Front Image",
        },
        {
          ...action.payload.vehicleleft_image,
          imageType: "Vehicle Left Image",
        },
        {
          ...action.payload.vehicleright_image,
          imageType: "Vehicle Right Image",
        },
        {
          ...action.payload.vehiclewithcustomer_image,
          imageType: "Vehicle With Customer Image",
        },
        {
          ...action.payload.vehiclechassis_image,
          imageType: "Vehicle Chassis Image",
        },

        {
          ...action.payload.vehicle_odomerter_image,
          imageType: "Vehicle Odometer Image",
        },

        { ...action.payload.rcfront_image, imageType: "RC Front Image" },
        { ...action.payload.rcback_image, imageType: "RC Back Image" },
      ];
      var NewImg = [
        {
          ...action.payload.vehicleback_image_latest,
          imageType: "Latest Vehicle Back Image",
        },
        {
          ...action.payload.vehiclefront_image_latest,
          imageType: "Latest Vehicle Front Image",
        },
        {
          ...action.payload.vehicleleft_image_latest,
          imageType: "Latest Vehicle Left Image",
        },
        {
          ...action.payload.vehicleright_image_latest,
          imageType: "Latest Vehicle Right Image",
        },

        {
          ...action.payload.vehicle_odomerter_image_latest,
          imageType: "Latest Vehicle Odometer Image",
        },
        { ...action.payload.rcfront_image, imageType: "RC Front Image" },
        { ...action.payload.rcback_image, imageType: "RC Back Image" },
      ]
    
      return {
        ...state,
        loading: false,
        incentiveLoading: false,
        godownStockData: action.payload,
        stockImages: action.payload.vehiclefront_image_latest ? NewImg  : oldImgs,
      };
    },
    QuickShellImagesByIDSuccessful: (state, action) => {
      var oldImgs = [
        {
          imageUrl: action.payload.vehicleback_image,
          imageType: "Vehicle Back Image",
        },
        {
          imageUrl: action.payload.vehiclefront_image,
          imageType: "Vehicle Front Image",
        },
        {
          imageUrl: action.payload.vehicleleft_image,
          imageType: "Vehicle Left Image",
        },
        {
          imageUrl: action.payload.vehicleright_image,
          imageType: "Vehicle Right Image",
        },

        {
          imageUrl: action.payload.otherimage,
          imageType: "Vehicle Odometer Image",
        },

      
      ];
      var NewImg = [
        {
          imageUrl :action.payload.vehicleback_image,
          imageType: "Latest Vehicle Back Image",
        },
        {
          imageUrl :action.payload.vehiclefront_image,
          imageType: "Latest Vehicle Front Image",
        },
        {
          imageUrl :action.payload.vehicleleft_image,
          imageType: "Latest Vehicle Left Image",
        },
        {
          imageUrl :action.payload.vehicleright_image,
          imageType: "Latest Vehicle Right Image",
        },

        {
          imageUrl :action.payload.otherimage,
          imageType: "Latest Vehicle Odometer Image",
        },
      ]
      console.log("action.payload.vehicleback_image",action.payload.vehicleback_image)
    console.log("new images",NewImg)
      return {
        ...state,
        loading: false,
        qs_images: action.payload.vehiclefront_image_latest ? NewImg  : oldImgs,
      };
    },

    InputChangeValue: (state, action) => {
      switch (action.payload.key) {
        case "counter__zone":
          return {
            ...state,
            godownStockParams: {
              ...state.godownStockParams,
              [action.payload.key]: action.payload.value,
              counter__cluster: null,
              counter__division: null,
              counter: null,
            },
          };

        case "counter__division":
          return {
            ...state,
            godownStockParams: {
              ...state.godownStockParams,
              [action.payload.key]: action.payload.value,
              counter__cluster: null,
              counter: null,
            },
          };

        case "counter__cluster":
          return {
            ...state,
            godownStockParams: {
              ...state.godownStockParams,
              [action.payload.key]: action.payload.value,
              counter: null,
            },
          };
        case "vehicle__version__brand":
          return {
            ...state,
            godownStockParams: {
              ...state.godownStockParams,
              [action.payload.key]: action.payload.value,
              vehicle__version__brandfamily: null,
              vehicle__version__model__name: null,
              vehicle__version: null,
            },
          };
        case "vehicle__version__brandfamily":
          return {
            ...state,
            godownStockParams: {
              ...state.godownStockParams,
              [action.payload.key]: action.payload.value,
              vehicle__version__model__name: null,
              vehicle__version: null,
            },
          };
        case "vehicle__version__model__name":
          return {
            ...state,
            godownStockParams: {
              ...state.godownStockParams,
              [action.payload.key]: action.payload.value,
              vehicle__version: null,
            },
          };
        case "stock_value_min":
          return {
            ...state,
            godownStockParams: {
              ...state.godownStockParams,
              [action.payload.key]: action.payload.value,
              stock_value_max: null,
            },
          };

        default:
          return {
            ...state,
            godownStockParams: {
              ...state.godownStockParams,
              [action.payload.key]: action.payload.value,
            },
          };
      }
      // return {
      //   ...state,
      //   godownStockParams: {
      //     ...state.godownStockParams,
      //     [action.payload.key]: action.payload.value,
      //   },
      // };
    },
    getVehicleAttendances: (state, action) => {
      return {
        ...state,
        loading: true,
        vehicleAttendanceslistCount: 0,
        vehicleAttendancesList: [],
      };
    },
    vehicleAttendancesSuccessful: (state, action) => {
      var noofpages = Math.ceil(
        action.payload.count / state.vehicleAttendanceParams.page_size
      );

      return {
        ...state,
        vehicleAttendanceslistCount: action.payload.count,
        vehicleAttendancesList: [
          ...state.vehicleAttendancesList,
          ...action.payload.results,
        ],
        loading: false,
        vehicleAttendanceParams: {
          ...state.vehicleAttendanceParams,
          no_of_pages: noofpages,
        },
      };
    },

    setVehicleAttendanceParams: (state, action) => {
      return {
        ...state,
        vehicleAttendanceParams: action.payload,
      };
    },

    getQRcodeactivity: (state, action) => {
      return {
        ...state,
        loading: true,
        qrCodeactivitylistCount: 0,
        qrCodeactivityList: [],
      };
    },

    qrCodeactivitySuccessful: (state, action) => {
      var noofpages = Math.ceil(
        action.payload.count / state.qrCodeactivityParams.page_size
      );
      return {
        ...state,
        qrCodeactivitylistCount: action.payload.count,
        qrCodeactivityList: [
          ...state.qrCodeactivityList,
          ...action.payload.results,
        ],
        loading: false,
        qrCodeactivityParams: {
          ...state.qrCodeactivityParams,
          no_of_pages: noofpages,
        },
      };
    },

    setQRCodeactivityParams: (state, action) => {
      return {
        ...state,
        qrCodeactivityParams: action.payload,
      };
    },

    qrCodeGenerate: (state, action) => {
      return {
        ...state,
        loading: true,
      };
    },
    getQRCodeData: (state, action) => {
      return {
        ...state,
        loading: true,
        QRCodeData: {},
      };
    },
    getQRCodeDataSuccessful: (state, action) => {
      return {
        ...state,
        loading: false,
        QRCodeData: action.payload,
        QRCodeModel: true,
      };
    },
    getQRCodeStatus: (state, action) => {
      return {
        ...state,
        loading: true,
        QRCodeStatus: action.payload,
      };
    },
    updateSpecialIncentive: (state, action) => {
      return {
        ...state,
        // loading: true,
        incentiveLoading: true
      };
    },
    updateMinimumSale: (state, action) => {
      return {
        ...state,
        loading: true,
      };
    },
    isModelVisible: (state, action) => {
      if (!action.payload) {
        return {
          ...state,
          model: action.payload,
          commentsData: {},
        };
      } else {
        return {
          ...state,
          model: action.payload,
          commentsData: {},
        };
      }
    },
    CommentInputChangeValue: (state, action) => {
      return {
        ...state,
        commentsData: {
          ...state.commentsData,
          [action.payload.key]: action.payload.value,
        },
      };
    },
    LocationInputChangeValue: (state, action) => {
      if(action.payload.key === "location"){
        return{
          ...state,
        stockLocationData: {
          [action.payload.key]: action.payload.value,
        },
        }
      }
      return {
        ...state,
        stockLocationData: {
          ...state.stockLocationData,
          [action.payload.key]: action.payload.value,
        },
      };
    },
    commentsAdd: (state, action) => {
      return{
        ...state,
        loading: true,
      }
    },
    commentAddSuccessful: (state, action) => {
      return{
        ...state,
        loading: false,
      }
    },
    isRatingModelVisible: (state, action) => {
      if (!action.payload) {
        return {
          ...state,
          ratingModel: action.payload,
          ratingData: {},
        };
      } else {
        return {
          ...state,
          ratingModel: action.payload,
          ratingData: {},
        };
      }
    },
    RatingInputChangeValue: (state, action) => {
      return {
        ...state,
        ratingData: {
          ...state.ratingData,
          [action.payload.key]: action.payload.value,
        },
      };
    },
    ratingAdd: (state, action) => {
      return{
        ...state,
        loading: true,
      }
    },
    ratingAddSuccessful: (state, action) => {
      return{
        ...state,
        loading: false,
      }
    },

    isStockImgModelVisible: (state, action) => {
      if (!action.payload) {
        return {
          ...state,
          imageModel: action.payload,
          stockImgData: {},
        };
      } else {
        return {
          ...state,
          imageModel: action.payload,
          stockImgData: {},
        };
      }
    },
    isStockLocationModelVisible: (state, action) => {
      if (!action.payload) {
        return {
          ...state,
          locationModel: action.payload,
          loading:false,
          stockLocationData: {},
        };
      } else {
        return {
          ...state,
          locationModel: action.payload,
          loading:false,
          stockLocationData: {},
        };
      }
    },
    // StockImgInputChangeValue: (state, action) => {
    //   return {
    //     ...state,
    //     stockImgData: {
    //       ...state.stockImgData,
    //       [action.payload.key]: action.payload.value,
    //     },
    //   };
    // },
    getStockImageUpload: (state, action) => {
      return {
        ...state,
        loading: true,
        imageLooading: true,
        stockImgData: {
          ...state.stockImgData,
          [action.payload.imageType]: null,
        },
      };
    },
    getStockLocationImageUpload: (state, action) => {
      console.log("action payload",action.payload)
      return {
        ...state,
        loading: true,
        imageLooading: true,
        stockLocationData: {
          ...state.stockLocationData,
          [action.payload.imageType]: null,
        },
      };
    },
    stockImageUploadSuccessful: (state, action) => {
      return {
        ...state,
        loading: false,
        imageLooading: false,
        stockImgData: {
          ...state.stockImgData,
          [action.payload.ImageType]: action.payload.response.data,
          [action.payload.ImageType + "_id"]: action.payload.response.data.id,
        },
      };
    },
    stockLocationImageUploadSuccessful: (state, action) => {
      return {
        ...state,
        loading: false,
        imageLooading: false,
        stockLocationData: {
          ...state.stockLocationData,
          [action.payload.ImageType]: action.payload.response.data,
          [action.payload.ImageType + "_id"]: action.payload.response.data.id,
        },
      };
    },
    stockImgAdd: (state, action) => {
      return{
        ...state,
        loading: true,
      }
    },  
    currentLocationAdd: (state, action) => {
      return{
        ...state,
        loading: true,
      }
    },  
    checkHotStock: (state, action) => {
      return{
        ...state,
        loading: true,
      }
    },
    apiError: (state, action) => {
      return { ...state, loading: false, error_msg: action.payload };
    },
  },
});

// Action creators are generated for each case reducer function
export const {
  getMyStockList,
  myStockListSuccessful,
  setMyStockParams,
  InputChangeValue,
  clearData,
  getMyStockById,
  myStockByIDSuccessful,
  getVehicleAttendances,
  vehicleAttendancesSuccessful,
  setVehicleAttendanceParams,
  getQRcodeactivity,
  qrCodeactivitySuccessful,
  qrCodeGenerate,
  getQRCodeData,
  getQRCodeDataSuccessful,
  setQRCodeactivityParams,
  getQRCodeStatus,
  clearStockList,
  updateSpecialIncentive,
  updateMinimumSale,
  isModelVisible,
  CommentInputChangeValue,
  commentsAdd,
  commentAddSuccessful,
  isRatingModelVisible,
  RatingInputChangeValue,
  ratingAdd,
  ratingAddSuccessful,
  isStockImgModelVisible,
  isStockLocationModelVisible,
  getStockLocationImageUpload,
  stockLocationImageUploadSuccessful,
  LocationInputChangeValue,
  // StockImgInputChangeValue,
  getStockImageUpload,
  stockImageUploadSuccessful,
  stockImgAdd,
  currentLocationAdd,
  getStockImgById,
  stockImgByIdSuccessful,
  checkHotStock,
  apiError,
  QuickShellImagesByIDSuccessful,
  getQuickShellImagesById
} = godownStockSlice.actions;

export default godownStockSlice.reducer;
